// Cliente HTTP do Ale — fala apenas com o NOSSO backend (proxy).
// A chave real da IA nunca passa por aqui; o navegador só carrega o token de sessão.
import api from '../../../services/api';

const aleHeaders = (token) => (token ? { 'X-Ale-Session': token } : {});

export const aleClient = {
  // Cria uma sessão anônima (o backend define a validade de ~7 dias).
  createSession: () => api.post('/ale/session'),

  // Envia mensagem para o Ale. `historico` = [{ role, text }].
  sendMessage: (mensagem, historico, token) =>
    api.post(
      '/ale/chat',
      { mensagem, historico },
      { headers: aleHeaders(token) }
    ),
};

export default aleClient;
